const fieldNamesMap = {
  name: "Naziv",
  "dims.height": "Visina stola",
  "dims.length": "Dužina stola",
  "dims.width": "Širina ploče",
  "legs.Materijal": "Materijal nogu",
  "legs.Boja": "Boja nogu",
  "legs.Model": "Model nogu",
  "board.Materijal": "Materijal ploče",
  "board.Završna obrada": "Završna obrada?",
  "board.Vrsta drveta": "Vrsta drveta",
  "board.Boja": "Boja ploče",
  "board.Debljina": "Debljina ploče",
  "board.Oblik": "Oblik ploče",
  "board.Ivica": "Ivica ploče",
  "board.Oblik ivice": "Oblik ivice ploče",
  "board.Češljano drvo": "Češljano drvo?",
};
// Flatten the object
const flattenObject = (obj, parentKey = "") =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    const newKey = parentKey ? `${parentKey}.${key}` : key;
    if (typeof value === "object" && value !== null) {
      Object.assign(acc, flattenObject(value, newKey));
    } else {
      acc[newKey] = value;
    }
    return acc;
  }, {});

// Prepare the product FormData
export const prepareProductFormData = (product) => {
  const transformed = {
    name:
      product.name === "full"
        ? "Ceo Sto"
        : product.name == "legs"
        ? "Noge"
        : "Ploca",
    dims: {},
  };

  if (product.legs) transformed.legs = product.legs;
  if (product.board) transformed.board = product.board;

  for (let key in product.dims) {
    transformed.dims[key] = product.dims[key].value;
  }

  // Flatten object
  const flat = flattenObject(transformed);

  // Map keys to human-readable names
  const humanReadable = {};
  for (const key in flat) {
    const newKey = fieldNamesMap[key] || key;
    humanReadable[newKey] = flat[key];
  }

  return humanReadable;
};
